
    import {Component, Prop} from 'vue-property-decorator';
    import AbpBase from '@/lib/abpbase'
    import {ChangePasswordInput} from "@/Areas/AppAreaName/Views/admin/entities/ChangePasswordInput";
    import {ChangePasswordEdit} from "@/Areas/AppAreaName/Views/admin/profile/ChangePasswordEdit";

    @Component
    export default class ChangePassword extends AbpBase {
        @Prop({type: Boolean, default: false}) value: boolean;
        changePasswordInput: ChangePasswordInput = new class implements ChangePasswordInput {
            currentPassword: string;
            newPassword: string;
        };
        changePasswordEdit: ChangePasswordEdit = new class implements ChangePasswordEdit {
            currentPassword: string;
            newPassword: string;
            newPasswordRepeat: string;
        };

        save() {
            const profileForm = (this.$refs.profileForm as any)
            profileForm.validate(async (valid: boolean) => {
                if (valid) {
                    this.changePasswordInput.currentPassword = this.changePasswordEdit.currentPassword;
                    this.changePasswordInput.newPassword = this.changePasswordEdit.newPassword;
                    await this.$store.dispatch('profile/changePassword', this.changePasswordInput
                    ).then(reponse => {
                        this.$Notice.success({
                            title: '修改密码成功!'
                        })
                        profileForm.resetFields();
                        this.$emit('input', false);
                    }).catch(reason => {
                        this.$Notice.error({
                            title: '修改密码失败',
                            desc: reason.error.message
                        })
                    });
                }
            })
        }

        cancel() {
            (this.$refs.profileForm as any).resetFields();
            this.$emit('input', false);
        }

        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            }
        }

        validateConfirmPassword1 = (rule, value, callback) => {
            if (value === '' || value === undefined || value === null) {
                callback(new Error('请输入新密码'))
            }
            var reg =new RegExp(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、])/);
            if (!reg.test(value)) {
                callback(new Error('密码最少6位且包含大小写字母和数字,并至少有一个非字母数字的特殊字符。'))
            }
            if (value === this.changePasswordEdit.currentPassword) {
                callback(new Error('新密码和当前密码不能一样!'))
            } else {
                callback()
            }
        };
        validateConfirmPassword2 = (rule, value, callback) => {
            if (value === '' || value === undefined || value === null) {
                callback(new Error('请再次输入新密码'))
            } else if (value !== this.changePasswordEdit.newPassword) {
                callback(new Error('两次输入密码不一致!'))
            } else {
                callback()
            }
        };
        profileRule = {
            currentPassword: [{
                required: true,
                message: this.L('FieldIsRequired', undefined, this.L('CurrentPassword')),
                trigger: 'blur'
            }],
            newPassword: [{
                required: true,
                validator: this.validateConfirmPassword1,
                trigger: 'blur'
            }],
            newPasswordRepeat: [{
                required: true,
                validator: this.validateConfirmPassword2,
                trigger: 'blur'
            }]
        }
    }
